import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const getRetentionReport = ({
    period,
    subscriptionType,
    year,
    managerId,
    clientType,
    includeInactive = false,
}) => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");

            // Build payload exactly once, keeping it explicit and backend-friendly
            const payload = {
                period,
                year,
                subscriptionType,
                managerId: managerId && managerId !== "all" ? managerId : null,
                clientType,
            };

            console.log("Payload for retention report:", payload);

            const response = await axios.post(
                `${FIRMFLOWURL}api/Analytics/GetRetentionReport`,
                payload,
                {
                    headers: { Authorization: token },
                    params: { includeInactive: Boolean(includeInactive) },
                }
            );

            resolve({ ...response, success: true });
        } catch (err) {
            console.log(err);
            const msg = err?.message || "Request failed";
            if (msg.includes(401)) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }
            resolve({ success: false, message: msg });
        }
    });
};
